export
const name: string = "SsaoMrtCutOff";

export
const preproc: string = `
    #ifdef WEBGL2
    layout(location = 0) out highp vec4 gbuf_position;
    layout(location = 1) out highp vec4 gbuf_normal;
    #else
    #extension GL_EXT_draw_buffers : require
    #endif
`;

export
const declaration: string = `
    uniform sampler2D u_heightTexture; // Special texture for grass cutoff under model
`;

export
const varyings: string = `
    varying vec3    v_position;
    varying vec3    v_normal;
    varying float   v_visibility;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main(void)
    {
        if (v_visibility < 0.5) {
            discard;
        }

        // Resolve height
        vec2 relative = v_relativePosition.xy / v_relativePosition.w * 0.5 + 0.5;
        vec4 heightData = texture2D(u_heightTexture, relative);

        // Test if any data was written
        if (heightData.x < 1.0 && heightData.y < 1.0 && heightData.z < 1.0 && heightData.w < 1.0) {
            float height = - vec4ToFloat(heightData);
            if (v_relativePosition.z / v_relativePosition.w >= height) {
                discard;
            }
        }

    #ifdef WEBGL2
        gbuf_position = vec4(v_position, 1.0);
        gbuf_normal = vec4(v_normal, 1.0);
    #else
        gl_FragData[0] = vec4(v_position, 1.0);
        gl_FragData[1] = vec4(v_normal, 1.0);
    #endif
    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
